import { GSearchSpinnerIcon } from '../app/icons/common-icons';

export default function PopupContentLoader() {
  return (
    <div className="align-center">
      <div className="g-helpertext-wrapper">
        <GSearchSpinnerIcon />
      </div>
    </div>
  );
}
